import React, { useState, useEffect } from "react";
import axiosInstance from "../config/axiosConfig";
import { formatDateTime } from "../utils/utils";
import Select from 'react-select';

const TIPOS_NOMBRE = {
    1: "Login",
    2: "Logout",
    3: "Registro Inicial",
    4: "Ingreso Enfermería",
    5: "Crear Acuerdo Mutuo",
    6: "Crear Paciente",
    7: "Registro Enfermería",
    8: "Crear Infraestructura",
    9: "Crear Documento",
    10: "Eliminar Documento",
    11: "Registro Visita",
    12: "Crear Usuario",
    13: "Subir Cartola",
    14: "Subir Boleta",
    15: "Asignar Movimiento",
    16: "Asignar Boleta",
    17: "Anular Boleta",
    18: "Eliminar Visita",
    19: "Cambiar Contraseña",
    20: "Recuperar Contraseña",
    21: "Editar Paciente",
    22: "Eliminar solicitud reemplazo",
    23: 'Se Reemplazo el auxiliar',
    24: 'Se agrego un auxiliar al turno',
    25: 'Se agrego un adicional al turno',
    26: 'Se agrego una nota al turno',
    27: 'Se elmino un turno',
};

function RegistroEventos() {
    // Estado para almacenar los valores de los filtros, la tabla de resultados y el término de búsqueda
    const [fechaDesde, setFechaDesde] = useState("");
    const [fechaHasta, setFechaHasta] = useState("");
    const [tipo, setTipo] = useState(null);
    const [resultados, setResultados] = useState([]);
    const [busqueda, setBusqueda] = useState("");

    const tipoOptions = Object.entries(TIPOS_NOMBRE).map(([key, value]) => ({
        value: key,
        label: value,
    }));

    // Función para buscar los resultados con Axios
    const buscarRegistro = async () => {
        try {
            const params = {
                desde: fechaDesde,
                hasta: fechaHasta,
                tipo: tipo?.value, // Enviamos el valor seleccionado del tipo
            };

            // Realiza la llamada a la API para obtener los eventos
            const response = await axiosInstance.get("/params/eventos", { params });
            setResultados(response.data.eventos); // Almacena los resultados en el estado
        } catch (error) {
            console.error("Error al buscar eventos: ", error);
        }
    };

    const resultadosFiltrados = resultados.filter((evento) => {
        return (
            (evento.usuario_nombre?.toLowerCase().includes(busqueda.toLowerCase()) ||
                evento.usuario_nombre == null) || // Asegurarse de que no sea undefined ni null
            (evento.fecha?.includes(busqueda) ||
                evento.fecha == null) || // Asegurarse de que no sea undefined ni null
            (evento.accion?.toLowerCase().includes(busqueda.toLowerCase()) ||
                evento.accion == null) // Asegurarse de que no sea undefined ni null
        );
    });


    return (
        <div className="container mt-4">
            <div className="card">
                <div className="card-body">
                    <h3 className="mb-4">Registro de Eventos</h3>

                    {/* Filtros de búsqueda */}
                    <div className="row g-3">
                        {/* Filtros por fechas */}
                        <div className="col-md-3">
                            <label className="form-label">Desde</label>
                            <input
                                type="date"
                                className="form-control"
                                value={fechaDesde}
                                onChange={(e) => setFechaDesde(e.target.value)}
                            />
                        </div>
                        <div className="col-md-3">
                            <label className="form-label">Hasta</label>
                            <input
                                type="date"
                                className="form-control"
                                value={fechaHasta}
                                onChange={(e) => setFechaHasta(e.target.value)}
                            />
                        </div>
                        <div className="col-md-3">
                            <label className="form-label">Tipo</label>
                            <Select
                                options={tipoOptions}
                                value={tipo}
                                onChange={setTipo}
                                placeholder="Seleccione un tipo"
                                isClearable
                            />
                        </div>
                        <div className="col-md-12 d-flex justify-content-center">
                            <button className="btn btn-primary" onClick={buscarRegistro}>
                                Buscar
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Card para la tabla de eventos */}
            <div className="card mt-3">
                <div className="card-body">
                    {/* Buscador dentro de la card de la tabla */}
                    <div className="mb-3">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Buscar en los registros"
                            value={busqueda}
                            onChange={(e) => setBusqueda(e.target.value)}
                        />
                    </div>

                    {/* Tabla de resultados */}
                    <div className="table-responsive">
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Usuario</th>
                                    <th>Fecha Evento</th>
                                    <th>Tipo</th>
                                    <th>Evento</th>
                                </tr>
                            </thead>
                            <tbody>
                                {resultadosFiltrados.length > 0 ? (
                                    resultadosFiltrados.map((evento, index) => (
                                        <tr key={index}>
                                            <td>{evento.usuario_nombre}</td>
                                            <td>{formatDateTime(evento.fecha)}</td>
                                            <td>{TIPOS_NOMBRE[evento.tipo]}</td>
                                            <td>{evento.accion}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="4" className="text-center">No se encontraron resultados</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default RegistroEventos;
